import gql from 'graphql-tag';
import FieldsCreditBundle from 'graphql/fields/FieldsCreditBundle';
import FieldsTransaction from 'graphql/fields/FieldsTransaction';

export default gql(`
	query transaction( $guid: String! ) {
		transaction( guid: $guid ) {
			${FieldsTransaction}
		}
	}
`);

